// @flow

import React, {Fragment} from 'react';

import StateButton from 'app/general/widgets/StateButton';
import {
  type AlertStatusType,
  getUserStatusAlerts,
} from 'app/user/users-statuses';

import {UserSerializedType} from 'sweet-types';

interface Action {
  action: null | (() => Promise<any>);
  condition: boolean;
}

interface Props {
  isSuperManager: boolean;
  user: UserSerializedType;
  actions: {[action: string]: Action};
  isSaml: boolean;
  refreshData?: () => unknown;
}

export const UserStatusesAlerts = ({
  isSuperManager,
  user,
  actions,
  isSaml,
  refreshData,
}: Props): JSX.Element => (
  <Fragment>
    {getUserStatusAlerts(user, isSaml).map(
      ({action, ActionButton, icon, color, alertDescription}) => (
        <div
          className={`mb-3 alert alert-${color} d-flex align-items-center justify-content-between`}
          key={color + icon}
        >
          <div className="flex-grow-0 mr-3">
            <i className={`fa-fw ${icon}`} />
          </div>
          <div className="flex-grow-1 d-flex align-items-center justify-content-between">
            {alertDescription}
            <CallToAction
              action={actions[action?.propName ?? '']}
              name={action?.name}
              ActionButton={ActionButton}
              user={user}
              refreshData={refreshData}
              isSuperManager={isSuperManager}
            />
          </div>
        </div>
      )
    )}
  </Fragment>
);

interface CallToActionProps {
  action: Action;
  name?: string;
  ActionButton?: AlertStatusType['ActionButton'];
  refreshData?: () => unknown;
  user: UserSerializedType;
  isSuperManager: boolean;
}
function CallToAction({
  action,
  name,
  refreshData,
  user,
  ActionButton,
  isSuperManager,
}: CallToActionProps) {
  if (!isSuperManager && action?.condition !== true) {
    return null;
  }

  return (
    <>
      {ActionButton != null ? (
        <ActionButton refreshData={refreshData} user={user} />
      ) : name && action.action ? (
        <StateButton
          className="btn alert-link btn-sm ml-2"
          onClick={action.action}
          busyText={name}
        >
          {name}
        </StateButton>
      ) : null}
    </>
  );
}
